import axios from "axios";
import {urlConfig} from "../config";

export default class OTTService {

    static getRegions() {

        const ottServiceInstance = axios.create({baseURL: `${urlConfig.bffUrl}/ott/regions`});

        return ottServiceInstance.get();
    }

}